import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PropTypes from "prop-types";

import { GlobalContext } from "../../context/GlobalContext";
import Index from "../../pages";
import AffiliateHealthForm from "../../pages/Health/AffiliateHealthForm";
import OptionsHealth from "../../pages/Health";
import OptionsServicesGuide from "../../pages/ServicesGuide";
import DirectoryMunicipalities from "../../pages/ServicesGuide/directoryMunicipalities";
import RUMV from "../../pages/LegalAndDocumental/RUMV";
import BiometricRegistration from "../../pages/LegalAndDocumental/BiometricRegistration";
import DocumentsDelivery from "../../pages/LegalAndDocumental/DocumentsDelivery";
import Login from "../../pages/Login";
import Main from "../../pages/Main";
import OthersForms from "../../pages/LegalAndDocumental/othersForms";
import DetailRegisterForms from "../../pages/LegalAndDocumental/DetailRegisterForms";
import ThemesInterest from "../../pages/InterestThemes/themesInterest";
import OptionsLegalAndDocumental from "../../pages/LegalAndDocumental";
import RegistersHealth from "../../pages/Health/RegistersHealth";
import DetailRegister from "../../pages/Health/DetailRegister";
import RegistersHealthStandard from "../../pages/Health/RegistersHealthStandard";
import OthersFormsStandard from "../../pages/LegalAndDocumental/othersFormsStandard";

const ProtectedRoute = ({ element }) => {
  const { token } = useContext(GlobalContext);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return element;
};

ProtectedRoute.propTypes = {
  element: PropTypes.element.isRequired,
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/legalAndDocumental/" element={<OptionsLegalAndDocumental />} />
      <Route path="/legalAndDocumental/RUMV" element={<RUMV />} />
      <Route path="/legalAndDocumental/BiometricRegistration" element={<BiometricRegistration />} />
      <Route path="/legalAndDocumental/DocumentsDelivery" element={<DocumentsDelivery />} />
      <Route path="/health/" element={<OptionsHealth />} />
      <Route path="/health/AffiliateFormHealth" element={<AffiliateHealthForm />} />
      <Route path="/login" element={<Login />} />
      {/* ---------- start logged ------------- */}
      <Route path="/main" element={<ProtectedRoute element={<Main />} />} />
      <Route path="/legalAndDocumental/OthersForms" element={<ProtectedRoute element={<OthersForms />} />} />
      <Route
        path="/legalAndDocumental/OthersFormsStandard"
        element={<ProtectedRoute element={<OthersFormsStandard />} />}
      />
      <Route path="/legalAndDocumental/DetailOthers" element={<ProtectedRoute element={<DetailRegisterForms />} />} />
      <Route path="/health/registersHealth" element={<ProtectedRoute element={<RegistersHealth />} />} />
      <Route
        path="/health/registersHealthStandard"
        element={<ProtectedRoute element={<RegistersHealthStandard />} />}
      />
      <Route path="/health/detailHealthRegister" element={<ProtectedRoute element={<DetailRegister />} />} />
      <Route path="/interestThemes" element={<ProtectedRoute element={<ThemesInterest />} />} />
      {/* ---------- end logged ------------- */}
      <Route path="/serviceGuide/" element={<OptionsServicesGuide />} />
      <Route path="/serviceGuide/Directory" element={<DirectoryMunicipalities />} />
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  );
};

export default AppRoutes;
